/* eslint-disable consistent-return */
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
} from '@material-ui/core';
import {
  deleteStudentExperience,
  getBusinesses,
  getJobs,
  postStudentExperience,
  updateStudentExperience,
} from '@webapps/business';
import {
  Autocomplete,
  FormikAutocomplete,
  FormikAutocompletePx,
  FormikDatePicker,
  FormikTextField,
  Loader,
  TextField,
  TextFieldPx,
  useAuth,
  useMutation,
  useQuery,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Row from 'components/Form/Row';
import { format } from 'date-fns';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';

const experienceSchema = yup.object().shape({
  label: yup.string().required('Requis'),
  company: yup.string().required('Requis'),
  contractType: yup.string().required('Requis'),
  city: yup.string().required('Requis'),
  encours: yup.bool(),
  startDate: yup.string().required('Requis'),
  endDate: yup.string().when('encours', {
    is: false,
    then: yup.string().required('Requis'),
  }),
  companyId: yup.string(),
});

const CONTRAT_TYPES = [
  {
    label: 'CDI',
    value: 'CDI',
  },
  {
    label: 'CDD',
    value: 'CDD',
  },
  {
    label: 'Intérimaire',
    value: 'INTERIM',
  },
  {
    label: 'Stage',
    value: 'STAGE',
  },
  {
    label: 'Apprentissage',
    value: 'APPRENTISSAGE',
  },
  {
    label: 'Professionnalisation',
    value: 'PROFESSIONNALISATION',
  },
  {
    label: 'Freelance',
    value: 'FREELANCE',
  },
  {
    label: 'Indépendant',
    value: 'INDEPENDANT',
  },
  {
    label: 'Service civique',
    value: 'SERVICE_CIVIQUE',
  },
  {
    label: 'VIE/VIA',
    value: 'VIE_VIA',
  },
];

const AddEditExperience = ({
  close,
  refetch,
  initialData = {},
  isLoadingEdit,
  idEdit,
}) => {
  const {
    css,
    theme: { spacing },
  } = useStyles();

  const { idUser } = useAuth();

  const handleChangeProgress = () => {
    formik.setFieldValue('encours', !formik?.values.encours);
  };

  const {
    isLoading,
    isSuccess,
    mutateAsync: mutateInterest,
  } = useMutation(postStudentExperience);

  const {
    isLoading: isLoadingUpdate,
    isSuccess: isSuccessUpdate,
    mutateAsync: mutateUpdateExperience,
  } = useMutation(updateStudentExperience);

  const {
    isLoading: isLoadingDelete,
    isSuccess: isSuccessDelete,
    mutateAsync: mutateDeleteExperience,
  } = useMutation(deleteStudentExperience);

  const [keywordRequest, setKeywordRequest] = useState('');

  const deleteExperience = async (id) => {
    await mutateDeleteExperience({
      id,
    });
  };

  const {
    data: { content: allBusiness = [] } = {},
    isLoading: businessLoading,
  } = useQuery(getBusinesses, {
    key: 'allBusinessInStudentProfil',
  });

  const { data: { content: jobs = [] } = {} } = useQuery(getJobs, {
    key: ['jobs', keywordRequest],
    variables: { keyword: keywordRequest },
  });

  const { addToast } = useToast();

  useEffect(() => {
    if (isSuccess || isSuccessDelete || isSuccessUpdate) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      refetch();
      close();
    }
  }, [isSuccess, isSuccessDelete, isSuccessUpdate]);

  const hanldeChangeCompany = (e) => {
    if (allBusiness?.filter(({ name }) => name === e.target.value).length > 0) {
      formik.setFieldValue(
        'companyId',
        allBusiness.filter(({ name }) => name === e.target.value)[0].id
      );
      formik.setFieldValue('company', e.target.value);
    } else {
      formik.setFieldValue('company', e.target.value);
      formik.setFieldValue('companyId', '');
    }
  };

  useEffect(() => {
    if (initialData?.label) {
      setKeywordRequest(initialData?.label);
    }
  }, [initialData]);

  const formik = useFormik({
    initialValues: {
      label: initialData?.label || '',
      company: initialData?.company || '',
      companyId: initialData?.companyId || '',
      contractType: initialData?.contractType || '',
      city: initialData?.city || '',
      startDate: initialData.startDate || '',
      endDate: initialData?.endDate || '',
      encours: !initialData?.endDate,
    },
    validationSchema: experienceSchema,
    enableReinitialize: true,
    onSubmit: async ({
      city,
      company,
      companyId,
      contractType,
      endDate,
      label,
      startDate,
    }) => {
      if (formik?.values?.encours) {
        if (idEdit) {
          await mutateUpdateExperience({
            data: {
              startDate: format(new Date(startDate), "yyyy-MM-dd'T'HH:mm:ss"),
              // endDate: format(new Date(endDate), "yyyy-MM-dd'T'HH:mm:ss"),
              company,
              companyId,
              city,
              label,
              contractType,
            },
            id: idEdit,
          });
        } else {
          await mutateInterest({
            data: {
              startDate: format(new Date(startDate), "yyyy-MM-dd'T'HH:mm:ss"),
              // endDate: format(new Date(endDate), "yyyy-MM-dd'T'HH:mm:ss"),
              company,
              companyId,
              city,
              label,
              contractType,
            },
            id: idUser,
          });
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (idEdit) {
          await mutateUpdateExperience({
            data: {
              startDate: format(new Date(startDate), "yyyy-MM-dd'T'HH:mm:ss"),
              endDate: format(new Date(endDate), "yyyy-MM-dd'T'HH:mm:ss"),
              company,
              companyId,
              city,
              label,
              contractType,
            },
            id: idEdit,
          });
        } else {
          await mutateInterest({
            data: {
              startDate: format(new Date(startDate), "yyyy-MM-dd'T'HH:mm:ss"),
              endDate: format(new Date(endDate), "yyyy-MM-dd'T'HH:mm:ss"),
              company,
              companyId,
              city,
              label,
              contractType,
            },
            id: idUser,
          });
        }
      }
    },
  });

  if (isLoadingEdit) {
    return <Loader />;
  }

  return (
    <div>
      <Row>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {/* <FormikTextField
              formik={formik}
              fullWidth
              label={<FormattedMessage id="addEditExperience.label" />}
              name="label"
            /> */}
            <FormikAutocompletePx
              formik={formik}
              borderRadius={6}
              freeSolo
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              getOptionSelected={(option, value) => value.ogr === option.ogr}
              label={<FormattedMessage id="addEditExperience.label" />}
              name="label"
              onInputChange={(event, value) => {
                setKeywordRequest(value);
              }}
              options={jobs}
              pathValue="label"
              value={
                jobs.find(({ label }) => label === formik.values.label) || null
              }
            />
            {/* <Autocomplete
              autoSelect
              defaultValue={initialData?.label}
              filterSelectedOptions
              freeSolo
              getOptionLabel={(option) => option.label || option}
              loading={businessLoading}
              loadingText={
                <>
                  <FormattedMessage id="loading" />
                  ...
                </>
              }
              onBlur={formik.handleBlur}
              onInputChange={(event, value) => {
                setKeywordRequest(value);
              }}
              options={jobs}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={<FormattedMessage id="addEditExperience.label" />}
                  name="label"
                />
              )}
            /> */}
          </Grid>
          <Grid item xs={12}>
            <Autocomplete
              autoSelect
              defaultValue={initialData?.company}
              filterSelectedOptions
              freeSolo
              getOptionLabel={(option) => option.name || option}
              loading={businessLoading}
              loadingText={
                <>
                  <FormattedMessage id="loading" />
                  ...
                </>
              }
              onBlur={formik.handleBlur}
              onChange={(e) => hanldeChangeCompany(e)}
              options={allBusiness}
              renderInput={(params) => (
                <TextFieldPx
                  {...params}
                  borderRadius={6}
                  label={<FormattedMessage id="addEditExperience.company" />}
                  name="company"
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              fullWidth
              borderRadius={6}
              label={<FormattedMessage id="addEditExperience.contractType" />}
              name="contractType"
              select
            >
              {CONTRAT_TYPES.map(({ label, value }, index) => (
                <MenuItem key={index} value={value}>
                  {label}
                </MenuItem>
              ))}
            </FormikTextField>
          </Grid>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              fullWidth
              borderRadius={6}
              label={<FormattedMessage id="addEditExperience.city" />}
              name="city"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              classes={{
                label: css({ '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' }, fontWeigt: 400 }),
              }}
              control={
                <Checkbox
                  checked={formik?.values?.encours}
                  color="primary"
                  name="encours"
                  onChange={handleChangeProgress}
                  size="small"
                />
              }
              label="Expérience  en cours"
            />
          </Grid>
          <Grid item xs={12}>
            <FormikDatePicker
              formik={formik}
              fullWidth
              borderRadius={6}
              label={<FormattedMessage id="addEditExperience.startDate" />}
              name="startDate"
              variant='outlined'
            />
          </Grid>
          {!formik?.values?.encours && (
            <Grid item xs={12}>
              <FormikDatePicker
                formik={formik}
                fullWidth
                borderRadius={6}
                label={<FormattedMessage id="addEditExperience.endDate" />}
                name="endDate"
                variant='outlined'
              />
            </Grid>
          )}
        </Grid>
      </Row>
      <Row>
        <Grid container spacing={2}>
          <Grid className={css({ textAlign: 'center' })} item xs>
            <Button
              className={css({ borderRadius: '400px' })}
              color="primary"
              disabled={isLoading || isLoadingUpdate || isLoadingDelete}
              onClick={formik.handleSubmit}
              variant="contained"
            >
              <FormattedMessage id="vitrine.btnCreate" />
            </Button>
            {idEdit && (
              <Button
                className={css({ borderRadius: '400px', marginLeft: spacing(1), backgroundColor: '#FBD3D5' })}
                color="secondary"
                disabled={isLoading || isLoadingUpdate || isLoadingDelete}
                onClick={() => deleteExperience(idEdit)}
                variant="outlined"
              >
                <FormattedMessage id="btnDelete" />
              </Button>
            )}
          </Grid>
        </Grid>
      </Row>
    </div>
  );
};

AddEditExperience.propTypes = {
  refetch: PropTypes.func,
  close: PropTypes.func,
  initialData: PropTypes.object,
  isLoadingEdit: PropTypes.bool,
  idEdit: PropTypes.string,
};

export default AddEditExperience;
